import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['whyModified', 'prospectiveRadio', 'notProspectiveRadio'];

  connect() {
    this.sync();
  }

  sync() {
    const selected = this.element.querySelector(
      'input[name*="[was_prospective]"]:checked'
    );
    const val = (selected?.value ?? '').toLowerCase();
    const isNo = val === '0' || val === 'false';

    if (isNo) {
      this.showWhy();
    } else {
      this.hideWhy();
    }
  }

  showWhy() {
    this.whyModifiedTarget.classList.remove('display-none');
  }

  hideWhy() {
    this.whyModifiedTarget.classList.add('display-none');
  }

  // Called from data-action on radios
  prospectiveChange(event) {
    const val = event.target.value;
    if (val === '0') this.showWhy();
    else this.hideWhy();
  }
}
